import { MessageDelayUnit } from "@prisma/client";
import { Limits } from "@/app/vars/Limits";

const UNIT_IN_MINUTES: Record<MessageDelayUnit, number> = {
  [MessageDelayUnit.MINUTE]: 1,
  [MessageDelayUnit.HOUR]: 60,
  [MessageDelayUnit.DAY]: 24 * 60,
};

const UNIT_MAX: Record<MessageDelayUnit, number> = {
  [MessageDelayUnit.MINUTE]: Limits.MAX_SEQUENCE_DELAY_MINUTE,
  [MessageDelayUnit.HOUR]: Limits.MAX_SEQUENCE_DELAY_HOUR,
  [MessageDelayUnit.DAY]: Limits.MAX_SEQUENCE_DELAY_DAY,
};

export class UMessageDelay {
  public static toMinutes(delay: number, unit: MessageDelayUnit): number {
    return (delay - 1) * UNIT_IN_MINUTES[unit];
  }

  public static toDays(delay: number, unit: MessageDelayUnit): number {
    return (
      Math.floor(UMessageDelay.toMinutes(delay, unit) / UNIT_IN_MINUTES[MessageDelayUnit.DAY]) + 1
    );
  }

  public static maxFor(unit: MessageDelayUnit): number {
    return UNIT_MAX[unit];
  }

  public static isValid(delay: number, unit: MessageDelayUnit): boolean {
    return Number.isInteger(delay) && delay >= 1 && delay <= UMessageDelay.maxFor(unit);
  }
}
